import {createReducer} from '@reduxjs/toolkit';
import {initialState, PreferencesState} from './state';
import {
    getCommunicationPreferences,
    updateCommunicationPreferences,
    clearAllAction,
    clearErrorsAction,
} from './actions';
import {ApiResponse} from "../../models";

const handlePendingFetch = (state: PreferencesState) => ({
    ...state,
    isFetching: true,
    errorMessage: undefined,
});

const handlePendingSave = (state: PreferencesState) => ({
    ...state,
    isSaving: true,
    errorMessage: undefined,
});

export const reducer = createReducer(initialState, builder =>
    builder
        .addCase(getCommunicationPreferences.pending, handlePendingFetch)
        .addCase(getCommunicationPreferences.fulfilled, (state, action) => {
            const results = action.payload.results;
            return {
                ...state,
                isFetching: false,
                marketingEmailStatus: results?.marketingEmailStatus !== undefined ? Number(results.marketingEmailStatus) : state.marketingEmailStatus,
                pushNotificationsStatus: results?.pushNotificationsStatus !== undefined ? Number(results.pushNotificationsStatus) : state.pushNotificationsStatus,
            };
        })
        .addCase(getCommunicationPreferences.rejected, (state, action) => {
            const {errorMessage} = action.payload as ApiResponse;
            return {...state, isFetching: false, errorMessage};
        })

        .addCase(updateCommunicationPreferences.pending, handlePendingSave)
        .addCase(updateCommunicationPreferences.fulfilled, (state, action) => {
            // If the API returns the updated status, we could use it here.
            // For now, we'll assume the update was successful and potentially re-fetch or use the submitted value.
            // The service returns ApiResponse which might not have the new status in results if it's just a message.
            return {
                ...state,
                isSaving: false,
            };
        })
        .addCase(updateCommunicationPreferences.rejected, (state, action) => {
            const {errorMessage} = action.payload as ApiResponse;
            return {...state, isSaving: false, errorMessage};
        })

        .addCase(clearErrorsAction.fulfilled, state => ({...state, errorMessage: undefined}))
        .addCase(clearAllAction.fulfilled, () => ({...initialState}))
);
